/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { types, getEnv } from 'mobx-state-tree';
import { FULFILLED, fromPromise } from 'mobx-utils';

export default types
	.model('NaturalLanguageTextModel', {
		id: types.string,
		shouldFetch: types.optional(types.boolean, false)
	})
	.volatile(() => ({
		items: null
	}))
	.views((self) => ({
		getItems() {
			let items;
			if (self.items && self.items.state === FULFILLED) {
				items = self.items.value;
			}
			return items || [];
		}
	}))
	.actions((self) => {
		function getFeature() {
			const { dashboardApi } = getEnv(self);

			return dashboardApi.getCanvasWhenReady()
				.then(canvas => {
					self.widgetContentApi = canvas.getContent(self.id);
					return canvas.getWidgetWhenReady(self.id);
				})
				.then(widget => {
					if (widget) {
						return widget.getFeature('vis-chart-insights');
					}
				});
		}

		return {
			afterCreate() {
				getFeature()
					.then(feature => {
						if (feature) {
							return feature.activate({
								widgetContentApi: self.widgetContentApi,
								cbChartInsightsUpdated: () => {
									self.setShouldFetch(true);
								}
							});
						}
					});
			},
			setShouldFetch(fetch) {
				self.shouldFetch = fetch;
			},
			fetchItems() {
				if (!self.shouldFetch) {
					return self.items || Promise.resolve();
				}

				self.setShouldFetch(false);

				const promise = fromPromise(
					getFeature()
						.then(feature => {
							if (feature) {
								return feature.getInsights();
							}
						})
						.then(response => {
							if (response) {
								return response.insights || [];
							}
							return [];
						})
				);

				self.items = promise;

				return promise;
			}
		};
	});



// WEBPACK FOOTER //
// ./src/js/components/nlt/NaturalLanguageTextModel.js